import { BannerWarning } from "./banner-warning";
import { Description } from "./description";
import { TooltipWarning } from "./tooltip-warning";

export const Warning = {
  BannerWarning,
  Description,
  TooltipWarning,
};
